import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=53106026&scoped=true"
import script from "./SelectWrapper.vue?vue&type=script&lang=js"
export * from "./SelectWrapper.vue?vue&type=script&lang=js"
import style0 from "./SelectWrapper.vue?vue&type=style&index=0&id=53106026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53106026",
  null
  
)

export default component.exports